import { useAtom } from "jotai/react";
import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai/vanilla";
import type { AccountInfo } from "@/api/models/accounts";

const accountInfoKey = "norgespris.fjernvarme.kundeportal.auth.user";

type AccountInfoWithTimestamp = AccountInfo & {
  timestamp: number;
};

const internalAccountInfoAtom =
  atomWithStorage<AccountInfoWithTimestamp | null>(accountInfoKey, null);

export const accountInfoAtom = atom(
  (get) => get(internalAccountInfoAtom),
  (_, set, update: AccountInfo | null) => {
    if (!update) {
      set(internalAccountInfoAtom, null);
      return;
    }
    const newAccountInfo: AccountInfoWithTimestamp = {
      ...update,
      timestamp: Date.now(),
    };
    set(internalAccountInfoAtom, newAccountInfo);
  },
);

export const useAccountState = () => useAtom(accountInfoAtom);
